// eslint-disable-next-line
(window as any).__Zone_disable_requestAnimationFrame = true;
// eslint-disable-next-line
(window as any).__Zone_disable_on_property = true;
// eslint-disable-next-line
(window as any).__Zone_disable_customElements = true;
// eslint-disable-next-line
(window as any).__zone_symbol__UNPATCHED_EVENTS = [
    "scroll",
    "mousemove",
    "mouseenter",
    "mouseleave",
    "mouseover",
    "mouseout",
    "wheel",
    "touchmove",
    "pointermove",
];
